import React from 'react';
var QRCode = require('qrcode.react');

export class QrCode extends React.Component<{value: string, size: number}> {

    render(){
        return <QRCode value={this.props.value} size={this.props.size}/>
    }
    
}